<script lang="ts">
	import { getContext } from "svelte";
	export let id: string = undefined;
	export let type: string;
	export let category: any;
	export let data: any;
	export let layout: string = "default";
	export let indexInContainer: number[];

	const context: SvelteStore<any> = getContext("context");
	const DOMAIN_VIEWS = getContext("DOMAIN_VIEWS");

	let view: any = undefined;

	function setView(_x: any, _y: any) {
		try {
			if (__ADMIN__) {
				view =
					DOMAIN_VIEWS[$context.page.domain].views[category][type][
						layout
					] ||
					DOMAIN_VIEWS[$context.page.domain].views[category][type]
						?.default;
			} else {
				view =
					DOMAIN_VIEWS[category][type][layout] ||
					DOMAIN_VIEWS[category][type].default;
			}
		} catch (e) {}
	}

	$: setView(layout, $context);
</script>

{#if view}
	<svelte:component this={view.default} {id} {type} {data} {indexInContainer}
		><slot /></svelte:component
	>
{:else}
	<slot />
{/if}
